import React from "react";

const Version = () => {
  const version = process.env.REACT_APP_VERSION || "dev";

  return (
    <span style={{ fontSize: "14px", color: "#999" }}>
      Version {version.split(".").join(" . ")}
    </span>
  );
};

export default Version;
